import { Text, Stack, Flex, SimpleGrid, Button } from "@chakra-ui/react";

import { useContext, useEffect, useState } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";
import { CardNewsList } from "../../../assets/datas/ConstantLists";
import CardNews from "../../../components/CardNews";
import { ReactComponent as ArrowLeft} from "../../../assets/icons/icon-arrow-simple-left.svg";
import { ReactComponent as ArrowRight} from "../../../assets/icons/icon-arrow-simple-right.svg";
import styled from "styled-components";

const PrevBar = styled(ArrowLeft)`
  margin: 0 20px;
  cursor: pointer;
`;

const NextBar = styled(ArrowRight)`
  margin: 0 20px;
  cursor: pointer;
`;

const NavBar = ({
  cnt,
  pager,
  _setPager,
}) => {
  const elements = [];
  for (let i=0; i < cnt; i++) {
    elements.push(
      <Text
        key={i}
        color={pager === i ? "black" : "#A1A1A1"}
        borderBottom={pager === i ? "1px solid black" : null}
        fontSize={"18px"}
        textAlign={"center"}
        margin={"0 10px"}
        cursor={"pointer"}
        onClick={() => _setPager(i)}
      >
        {i + 1}
      </Text>
    )
  }

  return (
    <Flex margin={"50px"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
      <PrevBar onClick={() => _setPager(pager - 1)} />
      <Flex>
        {elements}
      </Flex>
      <NextBar onClick={() => _setPager(pager + 1)} />
    </Flex>
  )
};


const Blog = () => {
  const screen = useContext(ScreenContext).style;
  const [selectedCategory, setSelectedCategory] = useState<string>("ALL");
  const [filteredList, setFilteredList] = useState<any[]>(CardNewsList);
  const [splitList, setSplitList] = useState<any[]>([]);
  const [viewList, setViewList] = useState<any[]>([]);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pager, setPager] = useState<number>(0);

  const baseUrl = "https://blog.naver.com/tbell2015/";

  const filterCategory = ["ALL", "NewsLetter", "티벨일상", "티벨 행사기록"];

  const _setCategory = (category: string) => {
    setSelectedCategory(category)
  }

  useEffect(() => {
    if (selectedCategory === "ALL") {
      setFilteredList(CardNewsList);
    }
    else {
      setFilteredList(CardNewsList.filter((item) => item.category === selectedCategory))  
    }
    setPager(0);
  }, [selectedCategory]);

  const chunkList = (list: any[], num: number) => {
    const resultList = [];
    for (let i=0; i < list.length; i += num) {
      resultList.push(list.slice(i, i + num))
    }
    return resultList;
  };

  useEffect(() => {
    const num = filteredList.length <= 6 ? 1 : Math.ceil(filteredList.length / 6);
    setPageNum(num);
    setSplitList(chunkList(filteredList, 6));
  }, [filteredList]);

  useEffect(() => {
    if(splitList.length > 0) {
      setViewList(splitList[pager])
    }
  }, [splitList, pager]);

  useEffect(() => {
  }, [viewList]);

  const isSelected = (item: String) => {
    return selectedCategory === item;
  };

  const _setPager = (num: number) => {
    if(num < 0 || num > pageNum - 1) return;
    setPager(num);
  };

  return (
    <Stack w={"100%"} alignItems={"center"} padding={"5vw"}>
      <Text color={"black"} fontSize={32} fontWeight={600}>기업문화</Text>
      <SimpleGrid
        width={screen === "mobile" ? "100%" : "60%"}
        margin={"40px 0 20px"}
        columns={screen === "mobile" ? 2 : 4}
      >
        {filterCategory.map((item, index) => {
          return (
            <Button 
              key={index}
              margin={"10px"} 
              width={"80%"} 
              borderRadius={0}
              background={isSelected(item) ? "#333333" : "#ECECEC"}
              color = {isSelected(item) ? "#ECECEC" : "#333333"}
              fontSize={"12px"}
              onClick={() => _setCategory(item)}
              _hover={{
                background: "#333333",
                color: "#ECECEC"
              }}
            >
              {item}
            </Button>
          )
        })}
      </SimpleGrid>
      <SimpleGrid
        margin={"20px 0"}
        columns={screen === "mobile" ? 1 : 3}
      >
        {viewList.map((item, index) => {
          return (
            <CardNews 
              key={index}
              screen={screen}
              img={item.img} 
              category={(item.sub ?? "") + item.category} 
              title={item.title} 
              content={item.content} 
              url={baseUrl + item.id} 
              created={item.created}            
            />
          )
        })}
      </SimpleGrid>
      <NavBar cnt={pageNum} pager={pager} _setPager={_setPager}></NavBar>
    </Stack>
  );
};

export default Blog;